module.exports = __webpack_public_path__ + "static/media/Courtney.35f8104b.png";